/* Glow Up - Geschenk-Modul
   Blendet die reinen Geschenk-Produkte ("...-gratis-geschenk") in Produktlisten
   aus (Suche, Predictive Search, Empfehlungen). Warenkorb-Zeilen bleiben
   unberuehrt.
   Ausgeblendet wird die ganze Raster-Zelle, nicht nur die Karte darin - sonst
   bleibt eine Luecke im Raster stehen.
   Ausserdem zaehlt Shopifys Trefferzaehler die versteckten Produkte mit; er
   wird nachtraeglich um die ausgeblendeten Treffer korrigiert. */
(function () {
  var SEL = 'a[href*="-gratis-geschenk"]';
  var BOX = '.predictive-search__list-item, .card-wrapper, .grid__item, .product-card, .swiper-slide, .card';
  var CELL = '.flex-grid__item, .grid__item, .swiper-slide, .predictive-search__list-item, li';
  var SAFE = '#gu-gifts, .gu-modal, .mini-cart, cart-drawer, #cart, .cart-items, .cart__items, form[action*="/cart"]';
  var COUNTERS = ['ProductCount', 'ProductCountDesktop', 'ProductCountMobile'];
  var NUM = /\d+(?:[.,]\d{3})*/;
  var NUM_ALL = /\d+(?:[.,]\d{3})*/g;

  function hide(el) {
    el.setAttribute('hidden', 'hidden');
    el.setAttribute('data-gu-hidden', '');
    el.style.display = 'none';
  }

  function clean() {
    var links = document.querySelectorAll(SEL);
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.closest) continue;
      if (a.closest(SAFE)) continue;
      var box = a.closest(BOX);
      if (!box) continue;
      var cell = box.closest(CELL);
      hide(cell && !cell.closest(SAFE) ? cell : box);
    }
    fixCount();
  }

  // Tausenderpunkt der Vorlage beibehalten: aus "1.240" soll "1.237" werden,
  // nicht "1237".
  function formatLike(sample, value) {
    var sep = sample.indexOf('.') >= 0 ? '.' : (sample.indexOf(',') >= 0 ? ',' : '');
    var s = String(value);
    if (!sep || s.length < 4) return s;
    var out = '';
    for (var i = s.length; i > 0; i -= 3) {
      out = s.slice(Math.max(0, i - 3), i) + (out ? sep + out : '');
    }
    return out;
  }

  // results_count kommt von Shopify und enthaelt die versteckten Produkte.
  // Abgezogen wird, was auf der Seite tatsaechlich ausgeblendet wurde. Der
  // Ausgangswert wird gemerkt, damit Nachladen (Infinite Scroll) nicht
  // mehrfach abzieht. Enthaelt der Text mehr als eine Zahl - etwa weil der
  // Suchbegriff selbst eine enthaelt - bleibt er unangetastet, statt die
  // falsche Zahl zu veraendern.
  function fixCount() {
    if (location.pathname.indexOf('/search') < 0) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var hidden = grid.querySelectorAll('[data-gu-hidden]').length;
    for (var i = 0; i < COUNTERS.length; i++) {
      var el = document.getElementById(COUNTERS[i]);
      if (!el) continue;
      if (!el.hasAttribute('data-gu-base')) {
        var found = (el.textContent || '').match(NUM_ALL);
        if (!found || found.length !== 1) continue;
        el.setAttribute('data-gu-base', el.textContent);
        el.setAttribute('data-gu-sample', found[0]);
        el.setAttribute('data-gu-num', found[0].replace(/[^0-9]/g, ''));
      }
      var base = parseInt(el.getAttribute('data-gu-num'), 10);
      if (isNaN(base)) continue;
      var shown = base - hidden;
      if (shown < 0) shown = 0;
      var next = el.getAttribute('data-gu-base')
        .replace(NUM, formatLike(el.getAttribute('data-gu-sample') || '', shown));
      if (el.textContent !== next) el.textContent = next;
    }
  }

  var t = null;
  function schedule() {
    if (t) return;
    t = setTimeout(function () { t = null; clean(); }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clean);
  } else {
    clean();
  }
  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
